import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export interface CurrentOrganizationManagementService {
  readonly currentOrganizationId$: Observable<string | null>;

  /**
   * Compute the current organization according to the currently stored org id in localstorage
   * and the orgs the user is manager of.
   */
  computeCurrentOrganization(): Observable<string | null>;
}

export const CURRENT_ORGANIZATION_MANAGEMENT_SERVICE =
  new InjectionToken<CurrentOrganizationManagementService>(
    'CURRENT_ORGANIZATION_MANAGEMENT_SERVICE'
  );
